import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import RadioInput from '@deliveroo/consumer-component-library/components/RadioInput';
import Span from '@deliveroo/consumer-component-library/components/Span';
import { fulfillmentMethodType, fulfillmentMethodsType } from './proptypes';

/**
 * Renders a simple list of radio buttons to let the consumer change the fulfillment method.
 * It internally re-uses `FilterList` component by translating the API response to a UIControl GraphQL type.
 */
const HomeFiltersFulfillmentControl = ({
  inputName,
  selectedMethod,
  availableMethods,
  showFulfillmentSwitchControl,
  onChange,
}) => {
  const [stateMethod, setStateMethod] = useState(selectedMethod);

  useEffect(
    () => {
      setStateMethod(selectedMethod);
    },
    [selectedMethod],
  );

  if (!showFulfillmentSwitchControl) {
    return null;
  }

  const onChangeHandler = (name, value) => {
    setStateMethod(value);
    return onChange(value);
  };

  return (
    <ul>
      {availableMethods.map(({ label, targetMethod }) => (
        <li key={targetMethod}>
          <RadioInput
            isBlock
            name={inputName}
            label={<Span size="small">{label}</Span>}
            value={targetMethod}
            isChecked={targetMethod === stateMethod}
            onChange={onChangeHandler}
            spacing="small"
          />
        </li>
      ))}
    </ul>
  );
};

HomeFiltersFulfillmentControl.propTypes = {
  /**
   * The HTML form name used to group the radio inputs together.
   */
  inputName: PropTypes.string.isRequired,

  /**
   * The currently selected fulfillment method.
   */
  selectedMethod: fulfillmentMethodType.isRequired,

  /**
   * The list of available fulfillment methods.
   */
  availableMethods: fulfillmentMethodsType.isRequired,

  /**
   * Whether the switch control should be rendered or not.
   */
  showFulfillmentSwitchControl: PropTypes.bool.isRequired,

  /**
   * The callback to be triggered after the user selects a fulfilment option.
   */
  onChange: PropTypes.func.isRequired,
};

export default HomeFiltersFulfillmentControl;
